<template>
  <div>

    <div class="vx-row mb-4">
      <div class="vx-col w-full">
        <vx-card class="mb-4" :style="`background: #${classroomData.color}`">
          <div class="flex justify-between items-center">
            <h1 class="font-bold">Meetings</h1>
            <vs-button color="white" :style="`color: #${classroomData.color}`" icon-pack="feather" icon="icon-plus" class="font-bold" @click="createToggle">Create New Meeting</vs-button>
          </div>
        </vx-card>
        <div v-if="meetingsActive.loaded">
          <div v-for="meeting in meetingsActive.data" :key="meeting.id">
            <classroom-meeting-card :meeting-id="meeting.id" :name="meeting.name" :description="meeting.description" :url="meeting.url" :color="classroomData.color" v-on:refresh="fetchInit"/>
          </div>
          <div class="flex justify-center cursor-pointer p-3">
            <h5 class="font-bold" v-if="currentPage < meetingsActive.pages" @click="loadMore">Load More</h5>
          </div>
        </div>
        <div class="simple-spinner" v-else>
          <span></span>
        </div>
      </div>
    </div>

    <vs-popup :active.sync="createPopup"  title="Create New Meeting">
      <div class="popup-input">
        <p class="mb-1 font-semibold">Name</p>
        <vs-input v-model="createValues.name" class="mb-3 w-full"/>

        <p class="mb-1 font-semibold">Description</p>
        <vs-input v-model="createValues.description" class="mb-3 w-full"/>

        <p class="mb-1 font-semibold">Meeting Url</p>
        <vs-input v-model="createValues.url" class="mb-4 w-full"/>

        <div class="flex justify-end mb-2">
          <vs-button color="danger" class="mr-2 font-bold" @click="createToggle">Cancel</vs-button>
          <vs-button :color="`#${classroomData.color}`" class="font-bold" @click="createMeeting">Create Meeting</vs-button>
        </div>
      </div>
    </vs-popup>

  </div>
</template>

<script>
import ClassroomMeetingCard from '../components/meeting/ClassroomMeetingCard'

export default {
  name: 'ClassroomStreamTab',
  data () {
    return {
      createPopup: false,
      createValues: {
        name: null,
        description: null,
        url: null
      },

      currentPage: 1,
      pageSize: 10,
      pagesLoaded: [],

      meetingsActive: {
        count: 0,
        pages: 0,
        data: [],
        loaded: false
      }
    }
  },
  components: {
    ClassroomMeetingCard
  },
  props: {
    classroomId: {
      type: String,
      required: true
    },
    classroomData: {
      type: Object,
      required: true
    }
  },
  methods: {
    createMeeting () {
      if (!this.classroomId) return
      this.createValues.classroom_id = this.classroomId
      this.$http.post('classrooms/meetings/create', this.createValues)
        .then(response => {
          if (response.status === 200) {
            this.fetchInit()
            this.$vs.notify({
              title: 'Meeting Created Successfully',
              text: `${this.createValues.name} has been updated.`,
              color: 'success',
              position: 'bottom-right',
              iconPack: 'feather',
              icon: 'icon-check-circle'
            })
            this.createToggle()
          }
        })
        .catch(exception => {
          this.fetchInit()
          let error = 'An unknown error occurred while creating this meeting'
          if (exception.response) {
            error = exception.response.data.error.description
          }
          this.$vs.notify({
            title: 'Failed To Create Meeting',
            text: error,
            color: 'danger',
            position: 'bottom-right',
            iconPack: 'feather',
            icon: 'icon-x-circle'
          })
          this.createToggle()
        })
    },
    createToggle () {
      this.createValues = {name: null, description: null, url: null}
      this.createPopup = !this.createPopup
    },
    fetchInit () {
      this.currentPage = 1
      this.meetingsActive = {count: 0, pages: 0, data: [], loaded: false}
      this.fetchClassroomMeetings()
    },
    fetchClassroomMeetings () {
      this.$http.get(`app/classroom/${this.classroomId}/meeting?amount=${this.pageSize}&page=${this.currentPage}`)
        .then(response => {
          if (response.data.data) {
            this.meetingsActive.count = response.data.data.count
            this.meetingsActive.pages = response.data.data.pages
            response.data.data.data.forEach(item => {
              this.meetingsActive.data.push(item)
            })
            this.meetingsActive.loaded = true
          }
        })
    },
    loadMore () {
      this.currentPage++
      this.fetchClassroomMeetings()
    }
  },
  mounted () {
    this.fetchInit()
  }
}
</script>

<style lang="scss">
.meeting-cards {
  .vs-collapse {
    padding: 0;
  }

  .vs-collapse-item--header {
    padding: 0;
  }

  .vs-collapse-item--icon-header {
    display: none;
  }

  .vs-collapse.default .open-item .con-content--item {
    padding: 0;
  }
}
</style>
